class NewDeferredMedia extends HTMLElement {
    constructor() {
        super();
        console.log("NewDeferredMedia",this,this.querySelector('[id^="Deferred-Poster-"]'))
        this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));

    }

    loadContent() {
        console.log("NewDeferredMedia loadContent")
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
            const newElement = document.createElement('div');
            newElement.className = 'new-video-popup';
            document.body.appendChild(newElement);
            document.body.style.overflow = "hidden"

            this.setAttribute('loaded', true);
            // console.log(this.parentNode,"nihao")
            // window.pauseAllMedia();
            this.parentNode.classList.add("deferred-media-wrapper");
            this.classList.add("newx");
            newElement.appendChild(content.querySelector('.template-wrapper'));

            var close_video = document.querySelector(".close-video");
            close_video.onclick = function (){
                document.body.style.overflow = "auto";
               const demos = document.querySelector(".deferred-media-wrapper .deferred-media");
                demos.removeAttribute('loaded');
                document.body.removeChild(newElement);
                // demos.removeChild(demos.lastChild);
                // document.querySelector(".new-video-popup").classList.remove("new-video-popup")
            }
        }


    }

}

customElements.define('new-deferred-media', NewDeferredMedia);
